import React from "react";
import ReactDOM from "react-dom/client";
import { App as AntdApp, ConfigProvider } from "antd";
import { App } from "./App.tsx";
import "./index.css";
import "./index.less";
import { AuthProvider } from "react-oidc-context";
import { BrowserRouter } from "react-router-dom";
import { featureFlagConfig } from "./config/feature-flag-config.tsx";
import { FeatureFlagProvider } from "./components/shared/feature-flag-react-lite/feature-flag-provider.tsx";
import { oidcConfig } from "./config/oidc-config";
import enUS from "antd/es/locale/en_US";

function ConfigProviderWrapper() {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#3f4373",
        },
        components: {
          Table: {
            headerBg: "#EAECFA",
            headerSortActiveBg: "#EAECFA",
            headerSortHoverBg: "#EAECFA",
            headerColor: "#000",
            rowHoverBg: "#d3d6f8", 
            rowSelectedBg: "#d3d6f8",
            rowSelectedHoverBg: "#d3d6f8",
            bodySortBg: "#fff",
          },
          Menu: {
            itemSelectedBg: "#d3d6f8",
            itemHoverBg: "#d3d6f8",
            itemActiveBg: "#d3d6f8",
          },
        },
      }}
    >
      <AntdApp>
        <App />
      </AntdApp>
    </ConfigProvider>
  );
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <FeatureFlagProvider config={featureFlagConfig}>
        <AuthProvider {...oidcConfig}>
          <ConfigProvider locale={enUS}>
            <ConfigProviderWrapper />
          </ConfigProvider>
        </AuthProvider>
      </FeatureFlagProvider>
    </BrowserRouter>
  </React.StrictMode>
);